import Cookies from 'js-cookie'
import { firebase, slidesCollection } from '@/firebase';
import { defaultLocale } from '@/i18n/config'
import { actions, mutations } from '../constants'

const ui = {
  state: {
    language: Cookies.get('language') || defaultLocale,
  },
  mutations:{
    [mutations.UI_SET_LANGUAGE](state, language){
      state.language = language;
      Cookies.set('language', language)
    },
  },
  actions:{
    [actions.UI_SET_LANGUAGE]({ commit }, language) {
      commit(mutations.UI_SET_LANGUAGE, language)
    },
    [actions.UI_GET_SLIDES]({rootState, state, commit}, {language, status}){
      let slidesRef = slidesCollection
      if(language){
        slidesRef = slidesRef.where('language','==',language);
      }
      if(status){
        slidesRef = slidesRef.where('status','==',status);
      }
      return slidesRef.get()
      .then(snapshot=>{
        const list = [];
        snapshot.forEach(doc=>{
          list.push(doc.data());
        });
        return Promise.resolve(list);
      });
    },
  }
};

export default ui;



// WEBPACK FOOTER //
// ./src/store/modules/ui.js